import $ from "jquery";
import debug from 'bows/dist/bows.min.js';

const log = debug("general");
const body = $('body');
const $gutenberg = $('.gutenberg');

function removeLastEmptyP() {
	let gpl = $('.gutenberg>p:last-child:empty');
	if (gpl.length) {
		gpl.remove();
	}
}

function ctaFooter() {
	if ($('.cta').length === 0) {
		$('#footer').addClass('footer--no-cta');
	}
}

export function init() {
	removeLastEmptyP();
	ctaFooter();
}

export default {
	init
};
